// extracted by mini-css-extract-plugin
export default {"specialDiscount":"specialDiscountItemForm_specialDiscount__hwA8T"};